import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FFPaper from '../../shared/FFPaper';
import * as React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from 'recharts';
import Title from '../../shared/Title';
import { FunctionComponent } from 'react';
import KebabMenu, { defaultMenus } from '../../shared/KebabMenu';
import { GroupPercentage, PercentageValues } from '../../../model/enrollment';
import ChartContainer from '../../shared/ChartContainer';
import { useTranslation } from 'react-i18next';

const handler = (menu: string) => {
    console.log(menu);
}

const COLORS = ['#21539B', '#A0D5FF', '#218FE6'];
const RADIAN = Math.PI / 180;

type CircleLegendProps = {
    label: string,
    color: string,
    value: string
}

const CircleLegend: FunctionComponent<CircleLegendProps> = ({ label, color }) => {
    return (
        <Stack direction="column" sx={{ alignItems: 'left' }} spacing={1}>
            <Stack direction="row" sx={{
                padding: '2px 10px 2px 10px',
            }}>
                <Box sx={{
                    width: 22,
                    borderRadius: '50%',
                    height: 19,
                    backgroundColor: color,
                    padding: '0 0 0 0',
                }}>&nbsp;
                </Box>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%'
                }}>
                    <Typography sx={{
                        padding: '0px 10px 10px 15px',
                        color: 'primary.main',
                    }}>
                        {label}
                    </Typography>

                </Box>
            </Stack>
        </Stack>
    )
}


const renderCustomizedLabel = (data: { cx: number, cy: number, midAngle: number, innerRadius: number, outerRadius: number, percent: number, index: number }) => {

    const radius = data.innerRadius + (data.outerRadius - data.innerRadius) * 0.5;
    const x = data.cx + radius * Math.cos(-data.midAngle * RADIAN);
    const y = data.cy + radius * Math.sin(-data.midAngle * RADIAN);

    return (
        <text x={x} y={y} fill="white" textAnchor='middle' dominantBaseline="central" fontSize={10} >
            {`${(data.percent * 100).toFixed(0)}%`}
        </text>
    );
};

interface GroupPercentageProps {
    data?: GroupPercentage[];
}

function WeekTrafficPieChart({ data }: GroupPercentageProps) {

    const renderLegend = (props: any) => {
        const { payload } = props;

        return (
            <Box sx={{ pl: 10, mt: 0 }}>
                {
                    payload.map((entry: any, i: number) => {
                        const { payload: item } = entry;
                        return (
                            <CircleLegend key={i} label={item.groupName} color={COLORS[i % COLORS.length]} value={item.percentageValue} />
                        )
                    })
                }
            </Box>
        )
    }

    return (
        <React.Fragment>
            <ResponsiveContainer >
                <PieChart  >
                    <Pie
                        data={data}
                        labelLine={false}
                        innerRadius={15}
                        outerRadius={70}
                        cx={65}
                        dataKey="percentageValue"
                        label={renderCustomizedLabel}

                    >
                        {data && data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                    </Pie>
                    <Legend content={renderLegend} layout="vertical" verticalAlign="middle" align="center" />
                </PieChart>
            </ResponsiveContainer>
        </React.Fragment>
    );
}


export interface QualityScoreBreakdownProps {
    data?: PercentageValues;
}

export default function QualityScoreBreakdownCard({ data }: QualityScoreBreakdownProps) {
    const parsedData = data?.value?.map(({ groupName, percentages }) => ({
        groupName,
        percentageValue: Number(percentages.replace('%', '')),
        percentages
    }));
    const { t } = useTranslation();

    return (
        <Grid item={true} xs={6} sx={{ paddingTop: '10px', height: '100%' }}>
            <FFPaper
                elevation={3}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    justifyContent: 'top',
                    minWidth: '370px'
                }}
            >
                <KebabMenu
                    menus={defaultMenus}
                    handler={handler}
                />
                <Box sx={{
                    p: '10px'
                }}>
                    <Title notooltip={true}>{t('enroll_quality_score_breakdown_title')}</Title>
                </Box>
                <Box sx={{ minHeight: 160, display: 'flex', justifyContent: 'center', width: '100%', minWidth: 365, 
                                overflowX: 'auto' }}>
                    <Box sx={{ width: '95%', 
                                pl: 2,
                                pt: 1,
                                pb: 1,
                                minWidth: '360px',  }}>
                        <ChartContainer>
                            <WeekTrafficPieChart data={parsedData} />
                        </ChartContainer>
                    </Box>
                </Box>
            </FFPaper>
        </Grid>
    )

}
